import { format, date } from "../../../utils";

const mapDetails = (json) => {
	const {
		SapDocNo,
		sapDocType,
		docNo,
		docType,
		docDate,
		fromGstin,
		fromTrdName,
		fromAddr1,
		fromAddr2,
		actFromStateCode,
		fromStateCode,
		fromPincode,
		fromPlace,
		toGstin,
		totrdName,
		toAddr1,
		toAddr2,
		actToStateCode,
		toStateCode,
		toPincode,
		toPlace,
		transactionType,
		totInvValue,
		sgstValue,
		igstValue,
		cgstValue,
		transporterId,
		transMode,
		transDocDate,
		transDocNo,
		vehicleNo,
		vehicleType,
		ewbNo,
		ewbStatus,
		ewbValidity,
	} = json;

	return [
		[
			{ label: "SAP Document No.", value: SapDocNo, type: "string" },
			{ label: "SAP Document Type", value: sapDocType, type: "string" },
			{ label: "Document No.", value: docNo, type: "string" },
			{ label: "Document Type", value: docType, type: "string" },
			{ label: "Document Date", value: date(docDate), type: "date" },
			{ label: "Transaction Type", value: transactionType, type: "string" },
		],
		[
			{ label: "Ewaybill No.", value: ewbNo, type: "string" },
			{ label: "Ewaybill Status", value: ewbStatus, type: "string" },
			{ label: "Ewaybill Valid Until", value: date(ewbValidity), type: "date" },
		],
		[
			{
				label: "Total Value",
				value: format(totInvValue, null, null, 2),
				type: "number",
				align: "left",
			},
			{
				label: "SGST Value",
				value: format(sgstValue, null, null, 2),
				type: "number",
			},
			{
				label: "CGST Value",
				value: format(cgstValue, null, null, 2),
				type: "number",
			},
			{
				label: "IGST Value",
				value: format(igstValue, null, null, 2),
				type: "number",
			},
		],
		{
			title: "GSTIN From",
			rows: [
				[
					{ label: "GSTIN", value: fromGstin || "N/A", type: "string" },
					{ label: "Trade Name", value: fromTrdName || "N/A", type: "string" },
				],
				[
					{ label: "Address 1", value: fromAddr1 || "N/A", type: "string" },
					{ label: "Address 2", value: fromAddr2 || "N/A", type: "string" },
				],
				[
					{ label: "Place", value: fromPlace || "N/A", type: "string" },
					{
						label: "ACT State Code",
						value: actFromStateCode || "N/A",
						type: "string",
					},
					{
						label: "State Code",
						value: fromStateCode || "N/A",
						type: "string",
					},
					{ label: "Pincode", value: fromPincode || "N/A", type: "string" },
				],
			],
		},
		{
			title: "GSTIN To",
			rows: [
				[
					{ label: "GSTIN", value: toGstin || "N/A", type: "string" },
					{ label: "Trade Name", value: totrdName || "N/A", type: "string" },
				],
				[
					{ label: "Address 1", value: toAddr1 || "N/A", type: "string" },
					{ label: "Address 2", value: toAddr2 || "N/A", type: "string" },
				],
				[
					{ label: "Place", value: toPlace || "N/A", type: "string" },
					{
						label: "ACT State Code",
						value: actToStateCode || "N/A",
						type: "string",
					},
					{ label: "State Code", value: toStateCode || "N/A", type: "string" },
					{ label: "Pincode", value: toPincode || "N/A", type: "string" },
				],
			],
		},
		{
			title: "Transporter",
			rows: [
				[
					{
						label: "Transporter ID",
						value: transporterId || "N/A",
						type: "string",
					},
					{
						label: "Transport Mode",
						value: transMode || "N/A",
						type: "string",
					},
					{
						label: "Transport Document No.",
						value: transDocNo || "N/A",
						type: "string",
					},
					{
						label: "Transport Document Date",
						value: transDocDate || "N/A",
						type: "date",
					},
				],
				[
					{ label: "Vehicle No.", value: vehicleNo || "N/A", type: "string" },
					{
						label: "Vehicle Type",
						value: vehicleType || "N/A",
						type: "string",
					},
				],
			],
		},
	];
};

const mapCard = (json) => {
	const {
		SapDocNo,
		sapDocType,
		docNo,
		docType,
		docDate,
		ewbNo,
		ewbStatus,
		ewbValidity,
	} = json;
	return [
		[{ labels: ["SAP Document No."], value: SapDocNo, type: "string" }],
		[{ labels: ["SAP Document Type."], value: sapDocType, type: "string" }],
		[{ labels: ["Document No."], value: docNo, type: "string" }],
		[{ labels: ["Document Type"], value: docType, type: "string" }],
		[{ labels: ["Document Date"], value: date(docDate), type: "date" }],
		[{ labels: ["EWB No."], value: ewbNo, type: "string" }],
		[{ labels: ["EWB Status"], value: ewbStatus, type: "string" }],
		[{ labels: ["EWB Valid Until"], value: ewbValidity, type: "string" }],
	];
};

const mapper = (json, card, details) => {
	return {
		...json,
		name: json.name,
		shortName: json.name,
		details: details ? mapDetails(json) : [],
		card: card ? mapCard(json) : [],
	};
};

const header = [
	{
		label: ["SAP Document No."],
		align: "left",
		columnName: "SapDocNo",
		sortable: false,
	},
	{
		label: ["SAP Document Type"],
		align: "left",
		columnName: "SapDocType",
		sortable: true,
	},
	{
		label: ["Document No."],
		align: "left",
		columnName: "docNo",
		sortable: false,
	},
	{
		label: ["Document Type"],
		align: "left",
		columnName: "docType",
		sortable: true,
	},
	{
		label: ["Document Date"],
		align: "left",
		columnName: "docDate",
		sortable: true,
	},
	// {label: ['GSTIN From'], align: 'left', columnName: "docDate", sortable: true},
	// {label: ['GSTIN To'], align: 'left', columnName: "docDate", sortable: true},
	{ label: ["EWB No."], align: "left", columnName: "ewbNo", sortable: false },
	{
		label: ["EWB Status"],
		align: "left",
		columnName: "ewbStatus",
		sortable: true,
	},
	{
		label: ["EWB Valid Until"],
		align: "left",
		columnName: "ewbValidity",
		sortable: false,
	},
];

export default {
	map: mapper,
	header,
};
